import { Checkbox, FormControlLabel } from '@mui/material';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

const PublisherControlItem = ({ nameBase, id, name }) => {
  const { control } = useFormContext();

  const controlName = useMemo(() => `${nameBase}.${id}`, [nameBase, id]);

  return (
    <Controller
      name={controlName}
      control={control}
      defaultValue={false}
      render={({ field }) => (
        <FormControlLabel
          sx={{
            ':hover': {
              background: '#1b43321f',
            },
            fontSize: '16px',
            marginLeft: 0,
            borderRadius: '6px',
          }}
          control={<Checkbox sx={{ padding: '8px' }} {...field} checked={field.value} />}
          label={name}
        />
      )}
    />
  );
};

PublisherControlItem.propTypes = {
  nameBase: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default PublisherControlItem;
